import React, { useState, useRef, useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
    registerdOtp,
  LoginAPi,
  newSessionLoginAPI,
} from "../actioncreators/actioncreators";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import { loginResponse, clearSuperAdminOrgFilter } from "../actions/loanAction";
import { toast } from "react-toastify";
import ArthaContinueButton from "../fields/ArthaContinueButton";
import ArthaTRACK from "../Assets/LOGO.png";
import LoginPng from "../Assets/login.png";
import { Shield, ArrowRight, MapPin, Users, Clock, RefreshCw } from "lucide-react";
import "./LoginForm.css";

const RagisterOtpForm = () => {
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const email = useSelector((state) => state.FetchEmail);
  console.log(email);

  const [isInvalidOtp, setIsInvalidOtp] = useState(false);
  const [isInvalidpan, setIsInvalidpan] = useState(false);
  const [isApiDown, setIsApiDown] = useState(false);
  const [isButtonClicked, setIsButtonClicked] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { state } = location;
  const { mobile, panCard } = state || {};
  const loginresponse = useSelector((state) => state.loginResponse);
  const inputRefs = useRef([...Array(6)].map(() => React.createRef()));

  const [timer, setTimer] = useState(60); // 30 seconds timer
  const [isTimerActive, setIsTimerActive] = useState(true);
  const handleChange = (element, index) => {
    if (isNaN(element.value)) return;

    const updatedOtp = [...otp];
    updatedOtp[index] = element.value;
    setOtp(updatedOtp);

    // Focus next input only if a number was entered
    if (element.value && index < 5) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === 'Backspace') {
      e.preventDefault();
      const updatedOtp = [...otp];
      updatedOtp[index] = '';
      setOtp(updatedOtp);

      // Focus previous input when backspace is pressed
      if (index > 0) {
        inputRefs.current[index - 1].focus();
      }
    }
  };

  const handleVerifyClick = async (e) => {
    e.preventDefault();
    setIsButtonClicked(true);
    setIsLoading(true);
    const requestBody = {
      otp: otp.join(""), // Join the otp array into a string
    };

    if (otp.join("") === "") {
      setIsInvalidOtp(true);
      inputRefs.current[0].current.focus();
      setIsLoading(false); // Need to set loading to false here too
      setIsButtonClicked(false); // Need to set button click state here too
      return;
    }

    try {
      const response = await registerdOtp(requestBody);

      if (response.status === 200) {
        const responseData = response.data;

        if (responseData.businessStatusCode === 2) {
          if (responseData.message === "OTP has been validated") {
            localStorage.removeItem("timerStartTime");
            // Clear menu state to ensure Dashboard is highlighted on login
            localStorage.removeItem("activeMainIndex");
            localStorage.removeItem("activeSubIndex");
            localStorage.removeItem("label");
            // Clear any org/sub-org selection left over from a previous
            // session (see OtpForm.jsx for the full rationale - the Redux
            // store is persisted to localStorage in its entirety).
            dispatch(clearSuperAdminOrgFilter());
            dispatch(loginResponse({
              role_name: responseData.role_name || "ADMIN",
              full_name: responseData.full_name || "",
              user_id: responseData.user_id,
              org_id: responseData.org_id,
              orgName: responseData.orgName || "",
            }));
            navigate("/home");
            // navigate("/freeplan");
          } else {
            console.warn("Unexpected success message:", responseData.message);
          }
        } else {
          if (responseData.businessStatusSubCode === 1.1) {
            setIsInvalidOtp(true);
            toast.error("Invalid OTP. Please enter correct OTP.");
          } else if (
            responseData.businessStatusSubCode === 1.2 ||
            responseData.businessStatusSubCode === 1.3 ||
            responseData.businessStatusSubCode === 1.4
          ) {
            setIsInvalidpan(true);
            setIsInvalidOtp(true);
          } else if (responseData.errorCode === 1000) {
            setIsApiDown(true);
            navigate("/");
          } else {
            console.log("Unexpected response status:", response.status);
          }
        }
      } else {
        console.log("Unexpected response status:", response.status);
      }
    } catch (error) {
      // handleApiError(error);
      console.error("Login failed:", error);
      console.error("Error fetching loan data:", error);
    } finally {
      setIsLoading(false);
      setIsButtonClicked(false);
    }
  };

  useEffect(() => {
    if (isTimerActive && timer > 0) {
      const countdown = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
      return () => clearInterval(countdown);
    } else if (timer === 0) {
      setIsTimerActive(false); // Stop the timer when it hits 0
    }
  }, [isTimerActive, timer]);

  const handleResendOtp = async (e) => {
    e.preventDefault(); // Prevent form submission reload

    const requestBody = {
      email: email, // Only email is being sent
      ui: true,
    };

    try {
      const response = await LoginAPi(requestBody);

      if (response.status === 200) {
        const responseData = response.data;
        console.log(responseData);

        if (responseData.businessStatusCode === 2) {
          setTimer(60);
          setIsTimerActive(true);
          setOtp(["", "", "", "", "", ""]); // Clear OTP input boxes
          if (responseData.message === "OTP has been sent") {
            toast.success(response.message || "OTP Resend Successfully");

            navigate("/getOtp");
          } else {
            toast.info(response.message);
          }
        }
      } else {
        console.log("Unexpected response status:", response.status);
      }
    } catch (error) {
      console.error("Login failed:", error);
      console.error("Error fetching loan data:", error);
    }
  };

  return (
    <div className="row p-0 m-0 login-page-container">
      {/* Animated gradient background header */}
      <header className="col-12 shadow-sm login-header login-header-gradient">
        <div className="px-3 py-2 d-flex align-items-center justify-content-between">
          <img src={ArthaTRACK} alt="ArthaTRACK" className="login-logo login-logo-animated" />
          <div className="d-none d-md-flex gap-3 tracking-features">
            <div className="feature-badge">
              <MapPin size={14} />
              <span>GPS Tracking</span>
            </div>
            <div className="feature-badge">
              <Clock size={14} />
              <span>Live Time</span>
            </div>
            <div className="feature-badge">
              <Users size={14} />
              <span>Team Management</span>
            </div>
          </div>
        </div>
      </header>

      <main className="row m-0 login-main login-main-gradient">
        {/* Spacer - hidden on mobile */}
        <div className="d-none d-lg-block col-lg-1"></div>

        {/* Left Column - Illustration with floating animation */}
        <div className="d-none d-md-flex col-md-6 col-lg-5 bg-white rounded-lg text-center align-items-center justify-content-center shadow-lg mx-1 mx-lg-2 login-illustration-container illustration-card-animated">
          <div className="illustration-content">
            <div className="floating-animation">
              <img
                src={LoginPng}
                alt="ArthaTRACK"
                className="h-auto mx-auto object-contain login-illustration"
                style={{ maxWidth: "100%", width: "auto", maxHeight: "280px" }}
              />
            </div>
            <p className="text-center custom-blue-text mt-3 px-2 tagline-animated">
              Streamline attendance, payroll, and compliance by easily tracking when your team is working.
            </p>
            {/* Feature highlights */}
            <div className="features-grid">
              <div className="feature-item">
                <div className="feature-icon">
                  <MapPin size={18} />
                </div>
                <span className="feature-text">Real-time Location</span>
              </div>
              <div className="feature-item">
                <div className="feature-icon">
                  <Clock size={18} />
                </div>
                <span className="feature-text">Smart Timesheets</span>
              </div>
              <div className="feature-item">
                <div className="feature-icon">
                  <Users size={18} />
                </div>
                <span className="feature-text">Team Insights</span>
              </div>
            </div>
          </div>
        </div>

        {/* Right Column - OTP Form with modern design */}
        <div className="col-12 col-md-5 col-lg-4 bg-white rounded-lg shadow-lg mx-auto mx-md-1 mx-lg-2 text-center login-form-container form-card-animated">
          <div className="login-form-header">
            <div className="otp-shield-icon">
              <Shield size={48} className="text-primary" style={{ color: "#0f2043" }} />
            </div>
            <h1 className="fw-bold text-center fs-4 title-fade-in">Verify OTP</h1>
            <p className="subtitle-fade-in" style={{ color: "#666", fontSize: "14px", marginBottom: "1rem" }}>
              Enter the 6-digit code we sent to
            </p>
            <p className="fw-bold" style={{ color: "#0f2043", fontSize: "14px", wordBreak: "break-all" }}>
              {email}
            </p>
          </div>

          <form className="modern-form">
            <div className="otp-input-container-modern">
              <label className="otp-label">Enter OTP</label>
              <div className="d-flex justify-content-center flex-wrap mb-3">
                {otp.map((data, index) => (
                  <input
                    className="otp-input-modern"
                    type="text"
                    inputMode="numeric"
                    maxLength="1"
                    key={index}
                    value={data}
                    onChange={(e) => handleChange(e.target, index)}
                    onKeyDown={(e) => handleKeyDown(e, index)}
                    onFocus={(e) => e.target.select()}
                    ref={el => inputRefs.current[index] = el}
                  />
                ))}
              </div>

              <div className="resend-container">
                {isTimerActive ? (
                  <div className="timer-text">
                    <Clock size={14} />
                    <span>Resend OTP in {timer} sec</span>
                  </div>
                ) : (
                  <div
                    onClick={handleResendOtp}
                    className="resend-link"
                  >
                    <RefreshCw size={14} />
                    <span>Resend OTP</span>
                  </div>
                )}
              </div>

              <button
                onClick={handleVerifyClick}
                disabled={isLoading}
                className="modern-login-btn"
                type="button"
              >
                {isLoading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    Verifying...
                  </>
                ) : (
                  <>
                    Verify & Proceed
                    <ArrowRight className="btn-arrow" size={18} />
                  </>
                )}
              </button>
            </div>
          </form>

          {/* Trust indicators */}
          <div className="trust-indicators">
            <div className="trust-item">
              <div className="trust-checkmark">✓</div>
              <span>Secure & Encrypted</span>
            </div>
            <div className="trust-item">
              <div className="trust-checkmark">✓</div>
              <span>GDPR Compliant</span>
            </div>
          </div>
        </div>

        {/* Spacer - hidden on mobile */}
        <div className="d-none d-lg-block col-lg-1"></div>
      </main>

      {/* Floating particles background effect */}
      <div className="particles-background">
        <div className="particle particle-1"></div>
        <div className="particle particle-2"></div>
        <div className="particle particle-3"></div>
        <div className="particle particle-4"></div>
        <div className="particle particle-5"></div>
      </div>
    </div>
  );
};

export default RagisterOtpForm;
